import './Footer.css'

function Footer() {
    return (
        <footer>
            Destiny J. FSW @ Pursuit Jan. 2023
        </footer>
    );
}

export default Footer;